<template>
  <v-menu
    v-model="menuOpen"
    offset-y
    content-class="cameraMenu_menu"
    z-index="99"
    :left="!menuOnRight"
    :right="menuOnRight"
    :nudge-right="!menuOnRight ? 20 : 0"
    :nudge-left="menuOnRight ? 20 : 0"
    :attach="isAttach"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        text
        :class="[
          buttonClass,
          {
            'cameraMenu_menu-btn-small': smallDisplay,
            'menu-close': !menuOpen,
          },
          additionalClasses,
        ]"
        v-on="on"
      >
        <span class="icon icon-3dots" />
      </v-btn>
    </template>
    <v-list class="cameraMenu_menu-list">
      <v-list-item v-if="showAutoFocus && false" @click="$emit('onAutofocus')">
        <v-list-item-title>
          <AutofocusSVG color="#989898" size="21px" />
          <span class="cameraMenu_menu-help_label">オートフォーカス </span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="false">
        <v-list-item-title
          class="cameraMenu_menu-help"
          :class="{ ['cameraMenu-disabled']: !liveMode }"
        >
          <QualitySVG color="#989898" size="21px" />
          <span class="cameraMenu_menu-help_label">低遅延モード </span>
          <v-switch
            :ripple="false"
            dense
            :disabled="!liveMode"
            :input-value="liveMode === 'WebRTC'"
            hide-details=""
            @change="$emit('onLiveMode', $event)"
            @click.stop
          ></v-switch>
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="showAbout" @click="$emit('onHelp')">
        <v-list-item-title class="cameraMenu_menu-help">
          <HelpSVG color="#989898" size="21px" />
          <span class="cameraMenu_menu-help_label">カメラについて </span>
          <v-icon class="cameraMenu-collapse--icon" color="#c1c1c1" size="22">
            mdi-chevron-right
          </v-icon>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import HelpSVG from './icons/HelpSVG.vue';
import QualitySVG from './icons/QualitySVG.vue';
import AutofocusSVG from './icons/AutofocusSVG.vue';

export default {
  name: 'CameraMenu',
  components: {
    HelpSVG,
    QualitySVG,
    AutofocusSVG,
  },
  props: {
    showAutoFocus: {
      type: Boolean,
      default: false,
    },
    showAbout: {
      type: Boolean,
      default: false,
    },
    liveMode: {
      type: String,
      default: null,
    },
    smallDisplay: {
      type: Boolean,
      default: false,
    },
    menuOnRight: {
      type: Boolean,
      default: false,
    },
    isAttach: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: 'cameraMenu_menu-btn',
    },
    additionalClasses: {
      type: [String, Object, Array],
      default: '',
    },
  },
  data() {
    return {
      menuOpen: false,
    };
  },
};
</script>

<style lang="scss">
.cameraMenu {
  &-disabled {
    opacity: 0.8;
    pointer-events: none;
  }
  &-collapse--icon {
    margin-left: auto;
  }
  &_menu {
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
    background-color: #fff;
    &-help {
      &_label {
        display: flex;
        flex: 1;
        margin-left: 6px;
      }
    }
    &-btn {
      &.v-btn:not(.v-btn--round).v-size--default {
        font-size: 16px;
        height: 31px;
        padding: 0 5px;
        min-width: 31px;
      }
      .icon {
        color: #c9cbd5;
      }
      &-small {
        font-size: 19px !important;
        min-width: 0 !important;
        padding: 0px 0px 0px 5px !important;
        .icon-3dots {
          margin-left: 0 !important;
        }
      }
    }
    &-list.v-list {
      padding: 0;
      width: 260px;
      .v-list-item {
        min-height: 35px;
        &:first-child {
          padding-top: 10px;
        }
        &:last-child {
          padding-bottom: 10px;
        }
      }
      .v-list-item__title {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666;
        display: flex;
        align-items: center;
      }
      .icon {
        font-size: 24px;
        margin-right: 6px;
        color: #989898;
      }
    }
  }
}
</style>
